import { Component, effect, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { PrimeNGConfig } from 'primeng/api';
import * as layoutReducer from './+state/layout/layout.reducer';
import * as layoutActions from './+state/layout/layout.actions';
import * as layoutSelectors from './+state/layout/layout.selectors';
import { environment } from '../environments/environment';
import { AngularQueryDevtools } from '@tanstack/angular-query-devtools-experimental';

@Component({
    imports: [RouterModule, TranslateModule, AngularQueryDevtools],
    selector: 'kanzi-apes-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  layoutStore = inject(Store<layoutReducer.LayoutState>);
  languageSelected = this.layoutStore.selectSignal(
    layoutSelectors.getLayoutLanguage
  );

  langEffects = effect(() => {
    const lang = this.languageSelected();
    this.translate.use(lang);
  });
  public isProduction = environment.production;
  constructor(
    private translate: TranslateService,
    private primengConfig: PrimeNGConfig
  ) {
    this.translate.addLangs(['en', 'es', 'pr']);
    this.translate.setDefaultLang('en');
    const browserLang = this.translate.getBrowserLang();
    this.translate.use(
      browserLang ? (browserLang.match(/en|es/) ? browserLang : 'en') : 'en'
    );
    this.layoutStore.dispatch(
      layoutActions.changeLanguage({ language: this.translate.currentLang })
    );
  }
  ngOnInit() {
    this.primengConfig.setTranslation({
      emptyMessage: 'No se encontraron resultados',
    });
  }
}
